<ng-container
  *ngIf="
    alertAdvisoriesFacade.showAlertAdvisoriesHeader() &&
    alertAdvisoriesFacade.isReady()
  "
>
  <div class="idp-alert-advisories-container fixed right-0 left-0">
    <idp-alert-advisories
      [content]="alertAdvisoriesFacade.alertAdvisoriesContent()"
      (alertAdvisoryClosed)="close($event)"
      (analyticsEvent)="handleAnalytics($event)"
    ></idp-alert-advisories>
  </div>
</ng-container>
